.search-holder{position:relative}.search-holder input{border-radius:50px;padding-left:40px}.search-holder .icon-search{position:absolute;top:12px;left:15px;font-size:1rem}
/*# sourceMappingURL=mo-short-code-list.component-WFULTWHI.css.map */
